import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20megaphone%20and%20broadcast%20waves%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=adhero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: '広告・デジタルマーケティング',
  heroImage: HERO_IMG,
  tag: 'Ad Marketing',
  title: <>¥377億の運用実績が<br />証明するROI最大化</>,
  subtitle: '131件の広告プロジェクト、¥377億の広告費運用実績。あらゆるデジタルチャネルで成果にコミットした広告運用を提供します。',
  icon: 'ri-advertisement-line',
  services: [
    { icon: 'ri-search-line', title: 'リスティング広告', desc: 'Google・Yahoo!・BingなどのSEM広告を精密に運用し、購買意欲の高いユーザーを獲得します。' },
    { icon: 'ri-image-line', title: 'ディスプレイ広告', desc: 'バナー広告とプログラマティック広告で、ブランド認知と顕在需要を同時に取り込みます。' },
    { icon: 'ri-smartphone-line', title: 'SNS広告', desc: 'Facebook・Instagram・X・LINEなど主要SNSでの精度の高いターゲティング配信を実施します。' },
    { icon: 'ri-movie-line', title: '動画広告', desc: 'YouTube・各種動画プラットフォームで、高いエンゲージメントを生む動画広告を展開します。' },
    { icon: 'ri-repeat-2-line', title: 'リターゲティング', desc: 'サイト訪問者を追跡し、最適なタイミングで再アプローチして転換率を大幅に向上させます。' },
    { icon: 'ri-palette-line', title: 'クリエイティブ制作', desc: '932本以上のバナー制作実績を持つチームが、成果に直結するクリエイティブを制作します。' },
  ],
  stats: [
    { number: '131', label: '広告プロジェクト実績' },
    { number: '¥377億', label: '広告費運用総額' },
    { number: '932+', label: 'バナー制作本数' },
    { number: '4.1x', label: '平均ROAS向上率' },
  ],
  benefits: [
    '¥377億を超える広告費運用実績による豊富なノウハウと最適化技術',
    '継続的な最適化でROASを最大化し、無駄な広告費を削減',
    '精密なターゲティングで、適切なユーザーに適切なタイミングでリーチ',
    '透明性の高いレポーティングで、広告投資の効果を正確に把握',
    '複雑なマルチチャネル施策を一元管理し、相乗効果を生み出す',
    '業種・予算規模を問わず、最適な広告戦略をカスタマイズして提供',
  ],
};

export default function AdMarketingPage() {
  useSEO({
    title: '東京 広告・デジタルマーケティング TradFit株式会社 | ¥377億運用実績',
    description: 'TradFit株式会社の広告・デジタルマーケティングサービス。131件の広告プロジェクト、¥377億の広告費運用実績で成果にコミットします。',
    keywords: '広告運用, デジタルマーケティング, SEM, SNS広告, リターゲティング, 東京',
    path: '/ad-marketing',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('広告・デジタルマーケティング | TradFit株式会社', 'TradFit株式会社の広告・デジタルマーケティングサービス。', '/ad-marketing'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: '広告・デジタルマーケティング', path: '/ad-marketing' }]),
        generateServiceSchema('広告・デジタルマーケティング', '131件の広告プロジェクト、¥377億の広告費運用実績による広告・デジタルマーケティングサービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
